var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g2, _g3, _g4, _g5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g6, _path27, _path28, _path29, _rect, _rect2, _g7, _g8, _path30, _g9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuidedog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1698 11.3888L29.4298 15.0588C29.8798 15.5688 30.1298 16.2288 30.1298 16.9088V20.5288C30.1298 20.7688 29.8598 20.9088 29.6698 20.7688C28.6998 20.0988 28.1298 18.9988 28.1298 17.8188V17.1888C28.1298 16.9888 28.0498 16.7988 27.9098 16.6588L25.3398 14.1688L26.1698 11.3888Z",
    fill: "url(#paint0_radial_715_14816)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1698 11.3888L29.4298 15.0588C29.8798 15.5688 30.1298 16.2288 30.1298 16.9088V20.5288C30.1298 20.7688 29.8598 20.9088 29.6698 20.7688C28.6998 20.0988 28.1298 18.9988 28.1298 17.8188V17.1888C28.1298 16.9888 28.0498 16.7988 27.9098 16.6588L25.3398 14.1688L26.1698 11.3888Z",
    fill: "url(#paint1_radial_715_14816)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1698 11.3888L29.4298 15.0588C29.8798 15.5688 30.1298 16.2288 30.1298 16.9088V20.5288C30.1298 20.7688 29.8598 20.9088 29.6698 20.7688C28.6998 20.0988 28.1298 18.9988 28.1298 17.8188V17.1888C28.1298 16.9888 28.0498 16.7988 27.9098 16.6588L25.3398 14.1688L26.1698 11.3888Z",
    fill: "url(#paint2_radial_715_14816)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_715_14816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8027 13.1094L29.3965 16.0156V18.8906",
    stroke: "url(#paint3_linear_715_14816)",
    strokeWidth: 0.2
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0808 18.8488H20.0808L18.1308 27.5388C18.0908 27.6988 18.2108 27.8388 18.3708 27.8388H20.8108C20.9608 27.8388 21.0808 27.7388 21.1108 27.5988L23.0808 18.8488Z",
    fill: "url(#paint4_linear_715_14816)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 20.3888L27.2709 19.6088C27.1909 19.5588 27.1309 19.4588 27.1309 19.3588V14.0788C27.1309 11.6188 25.0409 9.67875 22.5909 9.86875L15.7709 10.7088C14.3009 10.8988 13.9009 9.46875 13.6609 8.86875L12.4109 5.74875C12.1909 5.20875 11.6709 4.84875 11.0909 4.84875H9.15086C7.38086 4.84875 5.84086 6.04875 5.41086 7.76875L5.31086 8.14876C5.21086 8.55876 4.83086 8.85875 4.40086 8.85875H2.89086C2.47086 8.85875 2.13086 9.18875 2.13086 9.60875V9.85875C2.13086 11.5188 3.47086 12.8588 5.13086 12.8588H6.82086C6.99086 12.8488 7.13086 12.9888 7.13086 13.1688V15.0488C7.13086 16.8388 7.84086 18.5588 9.11086 19.8188L7.38086 27.5588C7.34086 27.7188 7.46086 27.8588 7.62086 27.8588H10.0609C10.2109 27.8588 10.3309 27.7588 10.3609 27.6188L12.1009 19.8488H12.4009V19.8588H18.9609C19.7309 19.8588 20.4709 19.6888 21.1209 19.3788C21.1509 20.8888 22.0709 22.2388 23.4809 22.7988L25.9309 23.7788C26.0509 23.8288 26.1309 23.9388 26.1309 24.0688V27.5488C26.1309 27.7188 26.2709 27.8588 26.4409 27.8588H28.8209C28.9909 27.8588 29.1309 27.7188 29.1309 27.5488V21.6988C29.1309 21.1688 28.8709 20.6788 28.4409 20.3888Z",
    fill: "url(#paint5_linear_715_14816)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 20.3888L27.2709 19.6088C27.1909 19.5588 27.1309 19.4588 27.1309 19.3588V14.0788C27.1309 11.6188 25.0409 9.67875 22.5909 9.86875L15.7709 10.7088C14.3009 10.8988 13.9009 9.46875 13.6609 8.86875L12.4109 5.74875C12.1909 5.20875 11.6709 4.84875 11.0909 4.84875H9.15086C7.38086 4.84875 5.84086 6.04875 5.41086 7.76875L5.31086 8.14876C5.21086 8.55876 4.83086 8.85875 4.40086 8.85875H2.89086C2.47086 8.85875 2.13086 9.18875 2.13086 9.60875V9.85875C2.13086 11.5188 3.47086 12.8588 5.13086 12.8588H6.82086C6.99086 12.8488 7.13086 12.9888 7.13086 13.1688V15.0488C7.13086 16.8388 7.84086 18.5588 9.11086 19.8188L7.38086 27.5588C7.34086 27.7188 7.46086 27.8588 7.62086 27.8588H10.0609C10.2109 27.8588 10.3309 27.7588 10.3609 27.6188L12.1009 19.8488H12.4009V19.8588H18.9609C19.7309 19.8588 20.4709 19.6888 21.1209 19.3788C21.1509 20.8888 22.0709 22.2388 23.4809 22.7988L25.9309 23.7788C26.0509 23.8288 26.1309 23.9388 26.1309 24.0688V27.5488C26.1309 27.7188 26.2709 27.8588 26.4409 27.8588H28.8209C28.9909 27.8588 29.1309 27.7188 29.1309 27.5488V21.6988C29.1309 21.1688 28.8709 20.6788 28.4409 20.3888Z",
    fill: "url(#paint6_radial_715_14816)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 20.3888L27.2709 19.6088C27.1909 19.5588 27.1309 19.4588 27.1309 19.3588V14.0788C27.1309 11.6188 25.0409 9.67875 22.5909 9.86875L15.7709 10.7088C14.3009 10.8988 13.9009 9.46875 13.6609 8.86875L12.4109 5.74875C12.1909 5.20875 11.6709 4.84875 11.0909 4.84875H9.15086C7.38086 4.84875 5.84086 6.04875 5.41086 7.76875L5.31086 8.14876C5.21086 8.55876 4.83086 8.85875 4.40086 8.85875H2.89086C2.47086 8.85875 2.13086 9.18875 2.13086 9.60875V9.85875C2.13086 11.5188 3.47086 12.8588 5.13086 12.8588H6.82086C6.99086 12.8488 7.13086 12.9888 7.13086 13.1688V15.0488C7.13086 16.8388 7.84086 18.5588 9.11086 19.8188L7.38086 27.5588C7.34086 27.7188 7.46086 27.8588 7.62086 27.8588H10.0609C10.2109 27.8588 10.3309 27.7588 10.3609 27.6188L12.1009 19.8488H12.4009V19.8588H18.9609C19.7309 19.8588 20.4709 19.6888 21.1209 19.3788C21.1509 20.8888 22.0709 22.2388 23.4809 22.7988L25.9309 23.7788C26.0509 23.8288 26.1309 23.9388 26.1309 24.0688V27.5488C26.1309 27.7188 26.2709 27.8588 26.4409 27.8588H28.8209C28.9909 27.8588 29.1309 27.7188 29.1309 27.5488V21.6988C29.1309 21.1688 28.8709 20.6788 28.4409 20.3888Z",
    fill: "url(#paint7_radial_715_14816)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 20.3888L27.2709 19.6088C27.1909 19.5588 27.1309 19.4588 27.1309 19.3588V14.0788C27.1309 11.6188 25.0409 9.67875 22.5909 9.86875L15.7709 10.7088C14.3009 10.8988 13.9009 9.46875 13.6609 8.86875L12.4109 5.74875C12.1909 5.20875 11.6709 4.84875 11.0909 4.84875H9.15086C7.38086 4.84875 5.84086 6.04875 5.41086 7.76875L5.31086 8.14876C5.21086 8.55876 4.83086 8.85875 4.40086 8.85875H2.89086C2.47086 8.85875 2.13086 9.18875 2.13086 9.60875V9.85875C2.13086 11.5188 3.47086 12.8588 5.13086 12.8588H6.82086C6.99086 12.8488 7.13086 12.9888 7.13086 13.1688V15.0488C7.13086 16.8388 7.84086 18.5588 9.11086 19.8188L7.38086 27.5588C7.34086 27.7188 7.46086 27.8588 7.62086 27.8588H10.0609C10.2109 27.8588 10.3309 27.7588 10.3609 27.6188L12.1009 19.8488H12.4009V19.8588H18.9609C19.7309 19.8588 20.4709 19.6888 21.1209 19.3788C21.1509 20.8888 22.0709 22.2388 23.4809 22.7988L25.9309 23.7788C26.0509 23.8288 26.1309 23.9388 26.1309 24.0688V27.5488C26.1309 27.7188 26.2709 27.8588 26.4409 27.8588H28.8209C28.9909 27.8588 29.1309 27.7188 29.1309 27.5488V21.6988C29.1309 21.1688 28.8709 20.6788 28.4409 20.3888Z",
    fill: "url(#paint8_radial_715_14816)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 20.3888L27.2709 19.6088C27.1909 19.5588 27.1309 19.4588 27.1309 19.3588V14.0788C27.1309 11.6188 25.0409 9.67875 22.5909 9.86875L15.7709 10.7088C14.3009 10.8988 13.9009 9.46875 13.6609 8.86875L12.4109 5.74875C12.1909 5.20875 11.6709 4.84875 11.0909 4.84875H9.15086C7.38086 4.84875 5.84086 6.04875 5.41086 7.76875L5.31086 8.14876C5.21086 8.55876 4.83086 8.85875 4.40086 8.85875H2.89086C2.47086 8.85875 2.13086 9.18875 2.13086 9.60875V9.85875C2.13086 11.5188 3.47086 12.8588 5.13086 12.8588H6.82086C6.99086 12.8488 7.13086 12.9888 7.13086 13.1688V15.0488C7.13086 16.8388 7.84086 18.5588 9.11086 19.8188L7.38086 27.5588C7.34086 27.7188 7.46086 27.8588 7.62086 27.8588H10.0609C10.2109 27.8588 10.3309 27.7588 10.3609 27.6188L12.1009 19.8488H12.4009V19.8588H18.9609C19.7309 19.8588 20.4709 19.6888 21.1209 19.3788C21.1509 20.8888 22.0709 22.2388 23.4809 22.7988L25.9309 23.7788C26.0509 23.8288 26.1309 23.9388 26.1309 24.0688V27.5488C26.1309 27.7188 26.2709 27.8588 26.4409 27.8588H28.8209C28.9909 27.8588 29.1309 27.7188 29.1309 27.5488V21.6988C29.1309 21.1688 28.8709 20.6788 28.4409 20.3888Z",
    fill: "url(#paint9_radial_715_14816)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 20.3888L27.2709 19.6088C27.1909 19.5588 27.1309 19.4588 27.1309 19.3588V14.0788C27.1309 11.6188 25.0409 9.67875 22.5909 9.86875L15.7709 10.7088C14.3009 10.8988 13.9009 9.46875 13.6609 8.86875L12.4109 5.74875C12.1909 5.20875 11.6709 4.84875 11.0909 4.84875H9.15086C7.38086 4.84875 5.84086 6.04875 5.41086 7.76875L5.31086 8.14876C5.21086 8.55876 4.83086 8.85875 4.40086 8.85875H2.89086C2.47086 8.85875 2.13086 9.18875 2.13086 9.60875V9.85875C2.13086 11.5188 3.47086 12.8588 5.13086 12.8588H6.82086C6.99086 12.8488 7.13086 12.9888 7.13086 13.1688V15.0488C7.13086 16.8388 7.84086 18.5588 9.11086 19.8188L7.38086 27.5588C7.34086 27.7188 7.46086 27.8588 7.62086 27.8588H10.0609C10.2109 27.8588 10.3309 27.7588 10.3609 27.6188L12.1009 19.8488H12.4009V19.8588H18.9609C19.7309 19.8588 20.4709 19.6888 21.1209 19.3788C21.1509 20.8888 22.0709 22.2388 23.4809 22.7988L25.9309 23.7788C26.0509 23.8288 26.1309 23.9388 26.1309 24.0688V27.5488C26.1309 27.7188 26.2709 27.8588 26.4409 27.8588H28.8209C28.9909 27.8588 29.1309 27.7188 29.1309 27.5488V21.6988C29.1309 21.1688 28.8709 20.6788 28.4409 20.3888Z",
    fill: "url(#paint10_radial_715_14816)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 20.3888L27.2709 19.6088C27.1909 19.5588 27.1309 19.4588 27.1309 19.3588V14.0788C27.1309 11.6188 25.0409 9.67875 22.5909 9.86875L15.7709 10.7088C14.3009 10.8988 13.9009 9.46875 13.6609 8.86875L12.4109 5.74875C12.1909 5.20875 11.6709 4.84875 11.0909 4.84875H9.15086C7.38086 4.84875 5.84086 6.04875 5.41086 7.76875L5.31086 8.14876C5.21086 8.55876 4.83086 8.85875 4.40086 8.85875H2.89086C2.47086 8.85875 2.13086 9.18875 2.13086 9.60875V9.85875C2.13086 11.5188 3.47086 12.8588 5.13086 12.8588H6.82086C6.99086 12.8488 7.13086 12.9888 7.13086 13.1688V15.0488C7.13086 16.8388 7.84086 18.5588 9.11086 19.8188L7.38086 27.5588C7.34086 27.7188 7.46086 27.8588 7.62086 27.8588H10.0609C10.2109 27.8588 10.3309 27.7588 10.3609 27.6188L12.1009 19.8488H12.4009V19.8588H18.9609C19.7309 19.8588 20.4709 19.6888 21.1209 19.3788C21.1509 20.8888 22.0709 22.2388 23.4809 22.7988L25.9309 23.7788C26.0509 23.8288 26.1309 23.9388 26.1309 24.0688V27.5488C26.1309 27.7188 26.2709 27.8588 26.4409 27.8588H28.8209C28.9909 27.8588 29.1309 27.7188 29.1309 27.5488V21.6988C29.1309 21.1688 28.8709 20.6788 28.4409 20.3888Z",
    fill: "url(#paint11_linear_715_14816)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 20.3888L27.2709 19.6088C27.1909 19.5588 27.1309 19.4588 27.1309 19.3588V14.0788C27.1309 11.6188 25.0409 9.67875 22.5909 9.86875L15.7709 10.7088C14.3009 10.8988 13.9009 9.46875 13.6609 8.86875L12.4109 5.74875C12.1909 5.20875 11.6709 4.84875 11.0909 4.84875H9.15086C7.38086 4.84875 5.84086 6.04875 5.41086 7.76875L5.31086 8.14876C5.21086 8.55876 4.83086 8.85875 4.40086 8.85875H2.89086C2.47086 8.85875 2.13086 9.18875 2.13086 9.60875V9.85875C2.13086 11.5188 3.47086 12.8588 5.13086 12.8588H6.82086C6.99086 12.8488 7.13086 12.9888 7.13086 13.1688V15.0488C7.13086 16.8388 7.84086 18.5588 9.11086 19.8188L7.38086 27.5588C7.34086 27.7188 7.46086 27.8588 7.62086 27.8588H10.0609C10.2109 27.8588 10.3309 27.7588 10.3609 27.6188L12.1009 19.8488H12.4009V19.8588H18.9609C19.7309 19.8588 20.4709 19.6888 21.1209 19.3788C21.1509 20.8888 22.0709 22.2388 23.4809 22.7988L25.9309 23.7788C26.0509 23.8288 26.1309 23.9388 26.1309 24.0688V27.5488C26.1309 27.7188 26.2709 27.8588 26.4409 27.8588H28.8209C28.9909 27.8588 29.1309 27.7188 29.1309 27.5488V21.6988C29.1309 21.1688 28.8709 20.6788 28.4409 20.3888Z",
    fill: "url(#paint12_radial_715_14816)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 20.3888L27.2709 19.6088C27.1909 19.5588 27.1309 19.4588 27.1309 19.3588V14.0788C27.1309 11.6188 25.0409 9.67875 22.5909 9.86875L15.7709 10.7088C14.3009 10.8988 13.9009 9.46875 13.6609 8.86875L12.4109 5.74875C12.1909 5.20875 11.6709 4.84875 11.0909 4.84875H9.15086C7.38086 4.84875 5.84086 6.04875 5.41086 7.76875L5.31086 8.14876C5.21086 8.55876 4.83086 8.85875 4.40086 8.85875H2.89086C2.47086 8.85875 2.13086 9.18875 2.13086 9.60875V9.85875C2.13086 11.5188 3.47086 12.8588 5.13086 12.8588H6.82086C6.99086 12.8488 7.13086 12.9888 7.13086 13.1688V15.0488C7.13086 16.8388 7.84086 18.5588 9.11086 19.8188L7.38086 27.5588C7.34086 27.7188 7.46086 27.8588 7.62086 27.8588H10.0609C10.2109 27.8588 10.3309 27.7588 10.3609 27.6188L12.1009 19.8488H12.4009V19.8588H18.9609C19.7309 19.8588 20.4709 19.6888 21.1209 19.3788C21.1509 20.8888 22.0709 22.2388 23.4809 22.7988L25.9309 23.7788C26.0509 23.8288 26.1309 23.9388 26.1309 24.0688V27.5488C26.1309 27.7188 26.2709 27.8588 26.4409 27.8588H28.8209C28.9909 27.8588 29.1309 27.7188 29.1309 27.5488V21.6988C29.1309 21.1688 28.8709 20.6788 28.4409 20.3888Z",
    fill: "url(#paint13_radial_715_14816)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_715_14816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0371 14.2484C25.8371 11.5984 23.8861 10.8733 22.8027 10.842L21.1309 15.2795L26.0371 14.2484Z",
    fill: "url(#paint14_radial_715_14816)",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_715_14816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2695 13.1857V20.3872C25.2695 20.4754 25.316 20.557 25.3918 20.6021L27.4598 21.8317C27.5356 21.8768 27.582 21.9585 27.582 22.0466V26.5294",
    stroke: "url(#paint15_linear_715_14816)",
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_715_14816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9082 8.55762L13.8145 13.1263",
    stroke: "url(#paint16_linear_715_14816)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_715_14816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75932 5.95922C8.6802 5.64357 8.9189 5.33765 9.24431 5.33765H11.7598C12.407 5.33765 12.8858 5.9494 12.7262 6.57889L12.1943 8.69787C12.0435 9.32736 11.4761 9.77066 10.82 9.77066C10.1728 9.77066 9.60538 9.32736 9.44579 8.69787L8.75932 5.95922Z",
    fill: "#D68E5D",
    fillOpacity: 0.5
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6699 18.8488H15.6699L17.1299 27.5588C17.1599 27.7088 17.0399 27.8488 16.8799 27.8488H14.4399C14.2899 27.8488 14.1599 27.7388 14.1299 27.5888L12.6699 18.8488Z",
    fill: "url(#paint17_linear_715_14816)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38086 10.3488H2.88086C2.47086 10.3488 2.13086 10.0188 2.13086 9.59875C2.13086 9.18875 2.47086 8.84875 2.88086 8.84875H3.38086C3.79086 8.84875 4.13086 9.18875 4.13086 9.59875C4.13086 10.0188 3.79086 10.3488 3.38086 10.3488Z",
    fill: "url(#paint18_linear_715_14816)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38086 10.3488H2.88086C2.47086 10.3488 2.13086 10.0188 2.13086 9.59875C2.13086 9.18875 2.47086 8.84875 2.88086 8.84875H3.38086C3.79086 8.84875 4.13086 9.18875 4.13086 9.59875C4.13086 10.0188 3.79086 10.3488 3.38086 10.3488Z",
    fill: "url(#paint19_linear_715_14816)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4591 18.4588L12.1191 19.8588H18.9691C19.7391 19.8588 20.4791 19.6888 21.1291 19.3788C21.1291 18.5388 20.4491 17.8488 19.5991 17.8488H13.2291C12.8691 17.8488 12.5491 18.0988 12.4591 18.4588Z",
    fill: "url(#paint20_linear_715_14816)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28666 5.48033C9.20754 5.16469 9.44624 4.85876 9.77166 4.85876H12.6909C13.4209 4.85876 13.9609 5.54876 13.7809 6.25876L13.1809 8.64876C13.0009 9.35876 12.3609 9.85876 11.6309 9.85876C10.9009 9.85876 10.2509 9.35876 10.0809 8.64876L9.28666 5.48033Z",
    fill: "url(#paint21_linear_715_14816)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28666 5.48033C9.20754 5.16469 9.44624 4.85876 9.77166 4.85876H12.6909C13.4209 4.85876 13.9609 5.54876 13.7809 6.25876L13.1809 8.64876C13.0009 9.35876 12.3609 9.85876 11.6309 9.85876C10.9009 9.85876 10.2509 9.35876 10.0809 8.64876L9.28666 5.48033Z",
    fill: "url(#paint22_radial_715_14816)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28666 5.48033C9.20754 5.16469 9.44624 4.85876 9.77166 4.85876H12.6909C13.4209 4.85876 13.9609 5.54876 13.7809 6.25876L13.1809 8.64876C13.0009 9.35876 12.3609 9.85876 11.6309 9.85876C10.9009 9.85876 10.2509 9.35876 10.0809 8.64876L9.28666 5.48033Z",
    fill: "url(#paint23_linear_715_14816)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1304 10.3488C14.1304 10.0688 14.3504 9.84875 14.6304 9.84875C14.9104 9.84875 15.1304 10.0788 15.1304 10.3488V13.1929C15.6397 13.3926 16.0004 13.8886 16.0004 14.4688C16.0004 15.0489 15.6397 15.5449 15.1304 15.7446V19.8727H14.1304V15.7447C13.81 15.619 13.5484 15.3761 13.3984 15.0688H6.90039C6.62039 15.0688 6.40039 14.8488 6.40039 14.5688C6.40039 14.2888 6.62039 14.0688 6.90039 14.0688H13.3197C13.4419 13.6677 13.7432 13.3447 14.1304 13.1929V10.3488Z",
    fill: "url(#paint24_radial_715_14816)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1304 10.3488C14.1304 10.0688 14.3504 9.84875 14.6304 9.84875C14.9104 9.84875 15.1304 10.0788 15.1304 10.3488V13.1929C15.6397 13.3926 16.0004 13.8886 16.0004 14.4688C16.0004 15.0489 15.6397 15.5449 15.1304 15.7446V19.8727H14.1304V15.7447C13.81 15.619 13.5484 15.3761 13.3984 15.0688H6.90039C6.62039 15.0688 6.40039 14.8488 6.40039 14.5688C6.40039 14.2888 6.62039 14.0688 6.90039 14.0688H13.3197C13.4419 13.6677 13.7432 13.3447 14.1304 13.1929V10.3488Z",
    fill: "url(#paint25_linear_715_14816)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1304 10.3488C14.1304 10.0688 14.3504 9.84875 14.6304 9.84875C14.9104 9.84875 15.1304 10.0788 15.1304 10.3488V13.1929C15.6397 13.3926 16.0004 13.8886 16.0004 14.4688C16.0004 15.0489 15.6397 15.5449 15.1304 15.7446V19.8727H14.1304V15.7447C13.81 15.619 13.5484 15.3761 13.3984 15.0688H6.90039C6.62039 15.0688 6.40039 14.8488 6.40039 14.5688C6.40039 14.2888 6.62039 14.0688 6.90039 14.0688H13.3197C13.4419 13.6677 13.7432 13.3447 14.1304 13.1929V10.3488Z",
    fill: "url(#paint26_linear_715_14816)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1304 10.3488C14.1304 10.0688 14.3504 9.84875 14.6304 9.84875C14.9104 9.84875 15.1304 10.0788 15.1304 10.3488V13.1929C15.6397 13.3926 16.0004 13.8886 16.0004 14.4688C16.0004 15.0489 15.6397 15.5449 15.1304 15.7446V19.8727H14.1304V15.7447C13.81 15.619 13.5484 15.3761 13.3984 15.0688H6.90039C6.62039 15.0688 6.40039 14.8488 6.40039 14.5688C6.40039 14.2888 6.62039 14.0688 6.90039 14.0688H13.3197C13.4419 13.6677 13.7432 13.3447 14.1304 13.1929V10.3488Z",
    fill: "url(#paint27_linear_715_14816)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 14.5688L14.6304 10.3488",
    stroke: "url(#paint28_linear_715_14816)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 14.5688L14.6304 10.3488",
    stroke: "url(#paint29_linear_715_14816)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_715_14816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69336 14.1719L14.0059 10.7188",
    stroke: "url(#paint30_linear_715_14816)",
    strokeOpacity: 0.8,
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6602 8.86877C13.7602 9.11877 13.8902 9.52877 14.1202 9.88877L17.9902 4.95877C18.0402 4.89877 18.1102 4.85877 18.1902 4.85877H21.5302L14.2402 14.1488C14.0702 14.3688 14.1102 14.6788 14.3202 14.8488C14.4102 14.9188 14.5202 14.9588 14.6302 14.9588C14.7802 14.9588 14.9302 14.8888 15.0202 14.7688L22.6302 5.07877C22.8102 4.84877 22.8402 4.54877 22.7102 4.28877C22.5902 4.02877 22.3302 3.86877 22.0402 3.86877H18.1902C17.8002 3.86877 17.4502 4.03877 17.2102 4.34877L13.6602 8.86877Z",
    fill: "url(#paint31_linear_715_14816)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6602 8.86877C13.7602 9.11877 13.8902 9.52877 14.1202 9.88877L17.9902 4.95877C18.0402 4.89877 18.1102 4.85877 18.1902 4.85877H21.5302L14.2402 14.1488C14.0702 14.3688 14.1102 14.6788 14.3202 14.8488C14.4102 14.9188 14.5202 14.9588 14.6302 14.9588C14.7802 14.9588 14.9302 14.8888 15.0202 14.7688L22.6302 5.07877C22.8102 4.84877 22.8402 4.54877 22.7102 4.28877C22.5902 4.02877 22.3302 3.86877 22.0402 3.86877H18.1902C17.8002 3.86877 17.4502 4.03877 17.2102 4.34877L13.6602 8.86877Z",
    fill: "url(#paint32_linear_715_14816)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6602 8.86877C13.7602 9.11877 13.8902 9.52877 14.1202 9.88877L17.9902 4.95877C18.0402 4.89877 18.1102 4.85877 18.1902 4.85877H21.5302L14.2402 14.1488C14.0702 14.3688 14.1102 14.6788 14.3202 14.8488C14.4102 14.9188 14.5202 14.9588 14.6302 14.9588C14.7802 14.9588 14.9302 14.8888 15.0202 14.7688L22.6302 5.07877C22.8102 4.84877 22.8402 4.54877 22.7102 4.28877C22.5902 4.02877 22.3302 3.86877 22.0402 3.86877H18.1902C17.8002 3.86877 17.4502 4.03877 17.2102 4.34877L13.6602 8.86877Z",
    fill: "url(#paint33_radial_715_14816)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.11914,
    y: 7.84875,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "url(#paint34_linear_715_14816)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.11914,
    y: 7.84875,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "url(#paint35_linear_715_14816)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_715_14816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7578 5.91345L12.1328 8.80408",
    stroke: "url(#paint36_linear_715_14816)",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_715_14816)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.3516,
    y: 4.35999,
    width: 0.292857,
    height: 1.01274,
    transform: "rotate(38.085 22.3516 4.35999)",
    fill: "#C7C5C7",
    fillOpacity: 0.75
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12695 5.43921V13.1263C7.10322 12.9791 6.97425 12.8651 6.82086 12.8651H5.13086C3.47086 12.8651 2.13086 11.5251 2.13086 9.86514V9.62514C2.13086 9.20514 2.47086 8.86514 2.89086 8.86514H4.40086C4.83086 8.86514 5.21086 8.57514 5.31086 8.15514L5.40086 7.79514C5.65258 6.78824 6.28814 5.95612 7.12695 5.43921Z",
    fill: "url(#paint37_linear_715_14816)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_715_14816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8496 4.61719H21.5527",
    stroke: "url(#paint38_linear_715_14816)",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_715_14816",
    x: 25.9785,
    y: 12.2928,
    width: 4.26758,
    height: 7.34778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_715_14816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_715_14816",
    x: 19.1309,
    y: 8.84204,
    width: 8.90625,
    height: 8.4375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_715_14816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_715_14816",
    x: 22.7695,
    y: 10.6857,
    width: 7.3125,
    height: 18.3438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_715_14816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_715_14816",
    x: 9.4082,
    y: 6.05737,
    width: 6.90625,
    height: 9.56921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_715_14816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_715_14816",
    x: 7.74414,
    y: 4.33765,
    width: 6.01367,
    height: 6.43298,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_715_14816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_715_14816",
    x: 7.39375,
    y: 10.4188,
    width: 6.91172,
    height: 4.05308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_715_14816",
    x: 10.8828,
    y: 4.66345,
    width: 3.125,
    height: 5.39062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_715_14816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_715_14816",
    x: 21.2266,
    y: 3.85999,
    width: 1.85547,
    height: 1.97778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_14816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_715_14816",
    x: 17.4492,
    y: 4.21716,
    width: 4.50391,
    height: 0.800049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_14816"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5673 19.9687) rotate(-127.5) scale(8.58702 8.60002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E99A5C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3398 17.2812) rotate(-55.2467) scale(3.19493 4.80235)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C46116"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36116",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7196 21.741) rotate(-89.5493) scale(1.40966 1.97373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D878D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D878D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_14816",
    x1: 29.0549,
    y1: 14.8483,
    x2: 30.5931,
    y2: 19.6748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDEAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDEAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_14816",
    x1: 20.5989,
    y1: 27.8388,
    x2: 20.5989,
    y2: 19.5355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB8D98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270677,
    stopColor: "#E99974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#CF6247"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_14816",
    x1: 15.6309,
    y1: 9.35071,
    x2: 15.6309,
    y2: 23.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308833,
    stopColor: "#F7BC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B68"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2484 25.02) rotate(-44.3645) scale(7.69047 11.8948)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B68",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.69315 22.8315) rotate(-32.4511) scale(13.4009 19.6181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B68",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4358 25.2075) rotate(-48.1832) scale(3.60759 5.10865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C734C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C734C1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.00586 30.5312) rotate(-84.7261) scale(4.07977 13.2001)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C734C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C734C1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8184 30.0937) rotate(-88.9584) scale(3.43807 11.1239)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C734C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C734C1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_14816",
    x1: 0.443984,
    y1: 5.76159,
    x2: 6.44695,
    y2: 11.4706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA9068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9068",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6244 9.41943) rotate(170.53) scale(5.89062 1.54856)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA9068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9068",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.75526 19.6426) rotate(34.9411) scale(4.03941 4.90636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC531",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.2402 12.217) rotate(134.525) scale(9.33634 4.48114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDAAD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_715_14816",
    x1: 27.9124,
    y1: 20.3107,
    x2: 24.6943,
    y2: 28.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDAAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_715_14816",
    x1: 11.5957,
    y1: 8.0013,
    x2: 13.4082,
    y2: 12.4951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDAAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDAAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_715_14816",
    x1: 14.8995,
    y1: 27.8488,
    x2: 14.8995,
    y2: 19.5363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB8D98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270677,
    stopColor: "#E99974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#CF6247"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_715_14816",
    x1: 3.84961,
    y1: 9.59875,
    x2: 2.59961,
    y2: 9.59875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#6B5E60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_715_14816",
    x1: 4.44336,
    y1: 10.6112,
    x2: 4.44336,
    y2: 9.34558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#552D52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_715_14816",
    x1: 16.6241,
    y1: 18.3588,
    x2: 16.6241,
    y2: 19.8588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F595BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_715_14816",
    x1: 9.81836,
    y1: 5.48995,
    x2: 11.8184,
    y2: 8.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#EAA054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF86"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6621 6.73995) rotate(89.3514) scale(4.14089 4.67187)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51495,
    stopColor: "#CA9068",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_715_14816",
    x1: 9.64648,
    y1: 9.10933,
    x2: 10.959,
    y2: 8.7187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA9068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9068",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0523 15.0781) rotate(-165.118) scale(2.31192 1.99291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_715_14816",
    x1: 14.6304,
    y1: 10.1562,
    x2: 14.6304,
    y2: 12.3124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#773C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773C26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_715_14816",
    x1: 7.59914,
    y1: 14.1562,
    x2: 11.2004,
    y2: 14.5937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#773C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61322,
    stopColor: "#773C26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_715_14816",
    x1: 13.5679,
    y1: 19.8727,
    x2: 13.5679,
    y2: 16.6874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#903F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61322,
    stopColor: "#903F51",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_715_14816",
    x1: 14.6304,
    y1: 10.3488,
    x2: 7.44289,
    y2: 14.5688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E62DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_715_14816",
    x1: 9.66164,
    y1: 16.4062,
    x2: 10.7654,
    y2: 13.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4361D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4361D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_715_14816",
    x1: 8.59961,
    y1: 13.25,
    x2: 14.8652,
    y2: 9.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590099,
    stopColor: "#7DC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_715_14816",
    x1: 12.3177,
    y1: 8.96871,
    x2: 22.2551,
    y2: 4.43127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75707C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A19997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_715_14816",
    x1: 13.3802,
    y1: 8.40621,
    x2: 14.5677,
    y2: 9.09371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#847971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#847971",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_715_14816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3489 3.86878) rotate(131.402) scale(3.59118 3.15823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C5C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_715_14816",
    x1: 7.97852,
    y1: 8.84876,
    x2: 7.35352,
    y2: 8.84876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#6B5E60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_715_14816",
    x1: 8.27539,
    y1: 10.1987,
    x2: 8.27539,
    y2: 8.51119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#552D52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_715_14816",
    x1: 12.9364,
    y1: 7.54431,
    x2: 12.4658,
    y2: 9.30501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDAAC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_715_14816",
    x1: 4.62891,
    y1: 13.5853,
    x2: 4.62891,
    y2: 11.7463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD44B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8D98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_715_14816",
    x1: 23.5215,
    y1: 5.834,
    x2: 13.9142,
    y2: 5.69186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96668B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96668B",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidedog);
export default __webpack_public_path__ + "static/media/Guide dog.9dfcf08d3dbf14f1673efa0503b3573e.svg";
export { ForwardRef as ReactComponent };